module.exports = __webpack_public_path__ + "static/img/img_title_fr.7e30413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newYear-2023/img_title_fr.png
// module id = o+m0
// module chunks = 1